export default "__VITE_ASSET__BkU$4rHZ__"